//
//
//
//
//
//
//
//
//
//

import Expand from "@/transitions/Expand";
import Filter from "./Filter";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "MatrixFilters",
  props: ["data", "active", "id"],
  components: {
    matrixFilter: Filter,
    transitionExpand: Expand
  },
  computed: {
    ...mapGetters(["preFilters"])
  },
  methods: {
    ...mapMutations(["loadFilters"]),
    preSelect(filter) {
      let payload = {
        id: filter.id,
        tag: filter.data.tag,
        data: filter.data.values
      };
      this.loadFilters(payload);
    }
  },
  created() {
    if (this.preFilters) {
      let group = this.preFilters[this.id];
      if (group) {
        this.data.forEach(filter => {
          if (group.includes(filter.tag) || group.includes(filter.tag.toLowerCase()))
            this.preSelect({ id: this.id, data: filter });
        });
      }
    }
  }
};
